import React from 'react';
import SocialLogin from 'react-social-login';

/** Uses react-social-login HOC */
// We need this as a class because the HOC gives it a refs. As a stateless component we get the error:
// Stateless function components cannot be given refs. Attempts to access this ref will fail.
// eslint-disable-next-line react/prefer-stateless-function
class SocialLoginButton extends React.Component {
  render() {
    const {
      triggerLogin,
      triggerLogout,
      disabled,
      ...props
    } = this.props;
    /* const style = {
        display: 'inline-block',
        margin: '0.5em',
        width: '100%',
    }; */
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      React.createElement("div", Object.assign({
        className: "socialLoginButton"
      }, props, {
        onClick: e => {
          if (!disabled) {
            triggerLogin(e);
          }
        } /* style={style} */
      }), this.props.children)
    );
  }
}
SocialLoginButton.defaultProps = {
  disabled: false
};
export default SocialLogin(SocialLoginButton);